import { MessageCondition } from '../shared/message-condition/message-condition.model';


export class PriorityRules {

  constructor() {
    this.globalSort = PriorityRules.globalSortItems()[0];
    this.rules = [];
  }

  addRule(rule) {
    this.rules.push(rule);
  }

  deleteRule(index) {
    this.rules.splice(index, 1);
  }

  updateRule(index, rule) {
    this.rules[index] = rule;
  }

  static globalSortItems() {
    return ['oldest-conversation-first', 'newest-conversation-first', 'oldest-message-first', 'newest-message-first'];
  }

  static fromBackEnd(source) {
    const result = new PriorityRules();
    result.globalSort = source.globalSort;
    source.rules.forEach(
      sourceRule => result.addRule(PriorityRule.fromBackEnd(sourceRule)));
    return result;
  }
}


export class PriorityRule {

  constructor(title) {
    this.title = title;
    this.isActive = true;
    this.logicOperator = 'AND'; // can also be 'OR'
    this.conditions = [];
  }

  addCondition(condition) {
    this.conditions.push(condition);
  }

  deleteCondition(index) {
    this.condition.splice(index, 1);
  }

  static fromBackEnd(source) {
    const result = new PriorityRule(source.title);
    result.isActive = source.isActive;
    result.logicOperator = source.logicOperator;
    source.conditions.forEach(
      sourceCondition => result.addCondition(MessageCondition.fromBackEnd(sourceCondition)));
    return result;
  }
}
